import React from 'react';
import { useLocation } from 'react-router-dom';
import { useMaintenance } from '../context/MaintenanceContext';
import MaintenancePage from '../pages/MaintenancePage';

const MaintenanceGate = ({ children }) => {
  const { maintenanceMode, loading } = useMaintenance();
  const location = useLocation();

  if (loading) {
    return (
      <div className="maintenance-gate-loading" style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #81D000 0%, #6DB000 100%)',
        color: 'white',
        fontSize: '1.125rem'
      }}>
        Loading...
      </div>
    );
  }

  if (maintenanceMode && !location.pathname.startsWith('/admin')) {
    return <MaintenancePage />;
  }

  return children;
};

export default MaintenanceGate;
